// Sites Reducer

const cdrViewerReducerDefaultState = {
  cdrs: [],
  count: 0,
  currentPage: 1,
  isLoading: true,
  noErrors: true,
  message: '',
  cdrDetails: null,
  summary: null,
  summaryFeedback: null,
  notFound: false
};

const cdrViewerReducer = (state = cdrViewerReducerDefaultState, action) => {
  switch (action.type) {
    case 'SET_CDRS':
      return {
        ...state,
        cdrs: action.cdrs,
        count: action.count,
        currentPage: action.currentPage,
        isLoading: false
      };
    case 'SET_CDRS_ERROR':
      return {
        ...state,
        isLoading: false,
        noErrors: false,
        message: action.message
      };
    case 'RESET_CDRS':
      return {
        ...cdrViewerReducerDefaultState
      };
    case 'SET_CDR_DETAILS':
      return {
        ...state,
        cdrDetails: action.details
      };
    case 'SET_CDR_SUMMARY':
      return {
        ...state,
        summary: action.summary
      };
    case 'SET_CDR_SUMMARY_FEEDBACK':
      return {
        ...state,
        summaryFeedback: action.feedback
      };
    case 'CLEAR_CDR_SUMMARY':
      return {
        ...state,
        summary: null,
        summaryFeedback: null,
        notFound: false
      };
    case 'SET_CDR_SUMMARY_NOT_FOUND':
      return {
        ...state,
        summary: null,
        notFound: true
      };
    case 'TOGGLE_SUMMARY_PRIVACY':
      return {
        ...state,
        summary: {
          ...state.summary,
          is_private: !state.summary.is_private
        }
      };
    default:
      return state;
  }
};

export default cdrViewerReducer;
